import { TFunction } from 'i18next';

import { InputUnit, MeasurementType, SizeChartMeasurementOption, SupportedSizeChartCategory } from './sizeChart';

const titleByInputUnit: { [key in InputUnit]: string } = {
  cm: 'centimeters',
  in: 'inches',
};

export const titleForUnit = (unit: InputUnit) => {
  return titleByInputUnit[unit];
};

const titleByGarmentType: Record<SupportedSizeChartCategory, string> = {
  tshirts: 'T-shirts',
  shirts: 'Shirts & Blouses',
  sweatshirts_and_hoodies: 'Sweatshirts',
  coats_and_jackets: 'Coats & Jackets',
  dresses_and_jumpsuits: 'Dresses & Jumpsuits',
  suits: 'Suits & Blazers',
  jeans: 'Jeans',
  trousers: 'Pants',
  leggings: 'Leggings',
  shorts: 'Shorts',
  skirts: 'Skirts',
  swimwear: 'Swimear',
  bras: 'Bras',
  default: 'Other',
  shoes: 'Shoes',
  accessories: 'Accessories',
};

export const stringForGarmentType = (garmentType: SupportedSizeChartCategory) => {
  return titleByGarmentType[garmentType];
};

export const stringForSizeChartMeasurementOption = (option: SizeChartMeasurementOption, t: TFunction) => {
  const optionStrings: Record<SizeChartMeasurementOption, string> = {
    chest: t('LOC_MEASUREMENT_OPT_CHEST', { ns: 'model' }),
    waist: t('LOC_MEASUREMENT_OPT_WAIST', { ns: 'model' }),
    hip: t('LOC_MEASUREMENT_OPT_HIP', { ns: 'model' }),
    inseam: t('LOC_MEASUREMENT_OPT_INSEAM', { ns: 'model' }),
    height: t('LOC_MEASUREMENT_OPT_HEIGHT', { ns: 'model' }),
    armLength: t('LOC_MEASUREMENT_OPT_ARM_LENGTH', { ns: 'model' }),
    braCupDifference: t('LOC_MEASUREMENT_OPT_BRA_CUP', { ns: 'model' }),
    underbust: t('LOC_MEASUREMENT_OPT_UNDERBUST', { ns: 'model' }),
  };
  return optionStrings[option] ?? option;
};

const titleByMeasurementType: { [key in MeasurementType]: string } = {
  garment: 'Garment measurements',
  body: 'Body measurements',
};

export const titleForMeasurementType = (type: MeasurementType) => {
  return titleByMeasurementType[type];
};
